import useViewModel from './viewModel';
import Dropdown from '../Dropdown';
import { MultipleDropdownProps } from '../Dropdown/types';

export const MultipleDropdown = ({
  onChange,
  onBlur,
  options,
  value,
  configThemeMenuButton,
  configThemeMenuItem,
  hasScrollbar,
  onCreateOptions,
  type,
  renderInVirtual,
  allowCustomOptions,
}: MultipleDropdownProps) => {
  const viewModel = useViewModel({
    onChange,
    onBlur,
    options,
    value,
    hasScrollbar,
    type,
    allowCustomOptions,
  });

  return (
    <Dropdown
      {...viewModel}
      onCreateOptions={onCreateOptions}
      configThemeMenuItem={configThemeMenuItem}
      configThemeMenuButton={configThemeMenuButton}
      hasScrollbar={hasScrollbar}
      options={options}
      isMultiSelect={true}
      renderInVirtual={renderInVirtual}
    />
  );
};

export default MultipleDropdown;
